import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'Redux/store';
import { getOrder } from 'Redux/Order/reducer';
import { getDriver } from 'Redux/Driver/reducer';
import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import PageNav from 'Components/PageNav/PageNav';
import { Order } from 'Components/Order/Order';
import { Locations } from 'Components/Order/Locations/Locations';
import { InfoBlock } from 'Components/Order/InfoBlock/InfoBlock';
import { Rates } from 'Components/Order/Rates/Rates';
import { Contacts } from 'Components/Order/Contacts/Contacts';
import { Email as EmailComponent } from '../../Email/Email';
import styles from './BidDetails.module.scss';

export const BidDetails = () => {
  const params = useParams();
  const currentOrder = useSelector(selectCurrentOrder);
  const dispatch = useAppDispatch();
  const [rates, setRates] = useState({ broker: 0, driver: 0 });

  useEffect(() => {
    if (params.id) {
      const bidID = parseInt(params.id, 10);

      window.scrollTo({ top: 0 });

      dispatch(getOrder(bidID));
    }
  }, [params.id, dispatch]);

  useEffect(() => {
    if (currentOrder) {
      const { letter } = currentOrder;

      if (letter) {
        setRates({
          broker: letter.broker_price || 0,
          driver: letter.driver_price || 0,
        });

        dispatch(getDriver(letter.driver_id));
      }
    }
  }, [currentOrder, dispatch]);

  const inputRateHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    const parsedValue = Math.abs(parseFloat(value));

    setRates((prevState) => ({
      ...prevState,
      [name]: parsedValue || 0,
    }));
  };

  return (
    <div className={styles.bidDetails}>
      <PageNav content="My Bids" />

      <div className={styles.bidDetails__firstColumn}>
        <Order>
          <Locations />
          <InfoBlock />
          <Rates
            handleRateInput={inputRateHandler}
            brokerRate={rates.broker}
            driverRate={rates.driver}
          />
          <Contacts />
        </Order>
      </div>

      <div className={styles.bidDetails__secondColumn}>
        <EmailComponent brokerPrice={rates.broker} driverPrice={rates.driver} />
      </div>
    </div>
  );
};
